

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EntityModal extends Vue {
  @Prop({ default: () => false }) open!: boolean;
  @Prop({ default: () => false }) loading!: boolean;
  @Prop({ default: () => false }) maximized!: boolean;
  @Prop({}) contentStyle!: boolean;
  @Prop({}) contentClass!: boolean;
  // @Getter('user/defaultCurrency') currency!: string;

  onHide() {
    this.$emit('open:update', false);
  }

  onSubmit() {
    this.$emit('submit');
  }
}
